"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  route: {
    system: 'IMP',
    dashboard: 'Dashboard',
    desktop: 'Desktop',
    authApprove: 'AuthApprove',
    attentionShip: 'My Fleet',
    attentionBuz: 'Favourite',
    vesselDashboard: 'VesselDashboard',
    board: 'Dashboard',
    waitToList: 'To-Do Tasks',
    msgList: 'Msg List',
    guide: 'Guide',
    permission: 'Users and Authority',
    pagePermission: 'Menu',
    rolePermission: 'Role Permission',
    directivePermission: 'Directive Permission',
    icons: 'Icons',
    components: 'Components',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editor',
    dndList: 'Dnd List',
    splitPane: 'SplitPane',
    avatarUpload: 'Avatar Upload',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: 'Mixin',
    backToTop: 'Back To Top',
    dragDialog: 'Drag Dialog',
    dragSelect: 'Drag Select',
    dragKanban: 'Drag Kanban',
    charts: 'Charts',
    keyboardChart: 'Keyboard Chart',
    lineChart: 'Line Chart',
    mixChart: 'Mix Chart',
    example: 'Example',
    nested: 'Nested Routes',
    devieMenuBaseData: 'Device Base Data',
    shipRepair: 'Ship Repair',
    repairItem: 'Repair Item',
    dockRepairPlan: 'Dock Repair Plan',
    repairOrder: 'Repair Order',
    repairLegacy: 'Repair Legacy',
    repairShip: 'Repair Ship',
    statutory: 'Survey & Certificate',
    shipCertificate: 'Vessel Certificate',
    shipSurvey: 'Vessel Survey',
    surveyOrder: 'Survey Order',
    statutoryChange: 'Statutory Track',
    taskTracking: 'Task Tracking',
    dictionary: 'Dictionary',
    surveyItem: 'Survey Item',
    Table: 'Table',
    dynamicTable: 'Dynamic Table',
    dragTable: 'Drag Table',
    inlineEditTable: 'Inline Edit',
    complexTable: 'Complex Table',
    componentTable: 'Component Table',
    tab: 'Tab',
    form: 'Form',
    createArticle: 'Create Article',
    editArticle: 'Edit Article',
    articleList: 'Article List',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    mergeHeader: 'Merge Header',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: 'Theme',
    clipboardDemo: 'Clipboard',
    i18n: 'I18n',
    externalLink: 'External Link',
    profile: 'Account Info',
    country: 'Country',
    workConfig: 'Tasks Config',
    msgRemindConfig: 'Msg Remind Config',
    /* 基础数据 */
    materialApplyTem: 'Store Requision Template',
    purchaseStock: 'Purchase',
    sparePurchasingManage: 'Spare Part Purchase',
    allocateManage: 'Transfer',
    applySignManage: 'Receipt',
    spsInventoryRecordManage: 'In/Out',
    mtrInventoryRecordManage: 'In/Out',
    inventoryVerification: 'Inventory Check',
    logisticsTrackManage: 'Tracking',
    spareStockingManage: 'Spare Parts Inspect',
    prosOrderMainManage: 'Used Spare Part Control',
    spareOrder: 'Purchase Order',
    vesselReport: 'Vessel Report',
    vesselBasic: 'Vessel Management',
    vesselReportReq: 'Routine Report',
    shipMonthlyReport: 'Monthly Report',
    shipDynamic: 'Vessel Movement',
    Crew: 'Crew Management',
    crewpersonnel: 'Crew Personnel',
    CrewListMgr: 'Crew Pool',
    ChangeManMgr: 'Crew Requirement',
    ResumeListMgr: 'Crew Resume',
    InterViewMgr: 'Crew Interview',
    leaveMgr: 'Crew Resign',
    Deployment: 'Crew Deployment',
    CrewDeployStatistic: 'Onboard CrewList',
    Tsfshowlist: 'Deployment Plan',
    TransOrderMgr: 'Deployment Order',
    UserEdit13Top4: 'Sign-off Assessment',
    UserEdit13Records: 'Assessment Tracking',
    Cert: 'Crew Certificate',
    CertManage: 'Certificate Query',
    CertHandOver: 'Certificate Handover Tracking',
    CertMonitoring: 'Onboard Crew Cert. Tracking',
    Onboard: 'Onboard Crew Management',
    CrewHandOver: 'Handover To-do List',
    CrewLeave: 'Private Application',
    CrewAssess: 'Crew Assessment',
    CrewTrain: 'Crew Training',
    CrewTrainingStatic: 'CrewTraining Static',
    BasicData: 'Crew Basic Data',
    CertStandardMgr: 'Certificate Standard',
    CertInfoMgt: 'Certificate Information',
    Interface: 'Crew Data Interface',
    AccountSrv: 'Crew Account Service',
    crewdeploymentstatistic: 'Crew Deployment Statistic',
    CrewTrainings: 'Crew Training',
    ShoreBased: 'Shore-based Training',
    ComYearPlan: 'Training Schedule',
    Cotrnrec: 'Training Record',
    COTRNAPPRFilter: 'Training Evalution',
    TrainingNeeds: 'Training Request (Office)',
    OrientationMgt: 'Orientation',
    assessmentRecord: 'Training History Inquiry',
    ShipBoard: 'Ship Training',
    safetyOfficer: 'Safety Officer Training',
    MGT: 'Training Basic Data',
    BasicTrndrill: 'Training Item Setting',
    Materials: 'Training Materials',
    InfoManager: 'General Training Materials',
    CrewSalary: 'Crew Salary',
    CrewSaloryProcess: 'Crew Salory Process',
    SalaryStandard: 'SalaryStandard',
    PrDutyScaleMgr: 'Duty Scale Setting',
    Base_PrBase3Add: 'Agent Scale Setting',
    ShipScaleMgr: 'Ship Scale Setting',
    WpSailorScaleMgr: 'Personel Scale Setting',
    Compute: 'Salary Calculation',
    Useandstop: 'Salary Start/Stop',
    Adjustment: 'Salary Adjustment',
    PractDept: 'Activities Confirmation',
    Actsalary: 'Activities Salary Calculation',
    Prfa05addship: 'Month Payroll Confirmation',
    Payment: 'Salary Payment',
    Useredit15: 'Crew Bank Accounts Setting',
    RemmitMgr: 'Salary Payment MGT',
    SalaryQueryMW: 'Payroll Inquiry',
    SalaryFinance: 'Salary Financial MGT',
    ShowSapFrame2: 'Salary Payment Order',
    WageReturn: 'Salary Refund Process',
    ShowSapFrame3: 'Monthly CrewCost',
    ShowSapFrame: 'Monthly Cost Forecast',
    SalaryBasicData: 'Salary Basic Data',
    PrItemMgr: 'Salary Item Setting',
    CrewFare: 'Crew Cost',
    SettlementCenter: 'Payment Settlement',
    FareInput: 'Invoice Registration',
    FormGenFrame: 'Payment Request',
    FormFrame: 'Payment Approval',
    InterfacePending: 'Payment Inquiry',
    FormChkFrame: 'Invoice Payment Inquiry',
    /* 后台管理 */
    manage: 'System Management',
    organization: 'Org and Config',
    VscLog: 'Data Syn',
    ipPrincipal: 'Vessel PIC',
    personnel: 'Staff Info',
    CommVesselView: 'Vessel Cummunication Config',
    TableConfigView: 'Syn Table Config',
    LogFileView: 'Syn File Monitor',
    LogAttachmentView: 'Syn Attachment Monitor',
    payManage: 'PayManage',
    /* 体系管理 */
    qualityFileMgt: 'HSQEMS',
    manual: 'Manual & Booklet',
    learnAssign: 'Assign & Learn',
    examTest: 'Exam',
    qualityImplement: 'Implementation',
    circularManager: 'Circular & Rule',
    standard: 'Standard Code',
    qualityFile: 'Document',
    qualityRecord: 'Records',
    otherControlledFile: 'otherControlledFile',
    benchmark: 'HSQEMS Benchmarking',
    examQuestion: 'Examination Questions',
    examAssign: 'Exam Assign',
    exam: 'Examination',
    summary: 'Exam Statistic',
    qualitySuggest: 'Improvement Recommendation',
    moc: 'Management of Change',
    shoreReview: 'Company Management Review',
    shipReview: 'Master\'s SMS review',
    massTempWork: 'Mass Temp. Work',
    busComponentTop: 'BusComponentTop',
    busComponent: 'BusComponent',
    /** 物资*/
    materialPurchasingManage: 'Store Purchase',
    materialStockingManage: 'Store Inventory',
    materialStock: 'Material Stock',
    materialApply: 'Store Requisition',
    materialOrder: 'Purchase Order',
    purchaseHome: 'Home Page',
    materialType: 'Store Category',
    locationInfo: 'Location',
    mtrLogisticsTrackManage: 'Tracking',
    mtrApplySignManage: 'Receipt',
    mtrAllocateManage: 'Transfer',
    spareApply: 'Spare Part Requisition',
    /* 统计分析 */
    statisticalAnalysis: 'Statistics',
    drugListManage: 'Medicine list',
    onBoardPartsList: 'On-Board Spare Part List',
    onBoardMaterialList: 'On-Board Store Lsit',
    spareApplyTracking: 'Spare Part Requisition Tracking',
    materialApplyTracking: 'Store Requisition Tracking',
    sparePartsStatistical: 'Spare Parts Inspect',
    materialPartsStatistical: 'Store Inventory',
    budgetPerformance: 'Budget Performance',
    /* 集中采购管理 */
    centralizedProManagement: 'Centralized Procurement',
    cenProAgreement: 'Centralized Procurement',
    centralizedStatistical: 'Statistics',
    /* 新造船管理 */
    newShipManagement: 'New Buildiing',
    shipContractManagement: 'New Building Contract',
    warrantyManagement: 'Warranty Management',
    /* 结算中心 */
    accountingCenter: 'Settlement',
    accountBasic: 'Basic Data',
    paymentManage: 'Payment Manage',
    receiptManage: 'Receipt',
    reportManage: 'Report & Filing',
    relatedTransaction: 'Affiliated Transactions',
    departmentSubjects: 'Configuration',
    invoiceRegister: 'Invoice Register',
    registrationAdvance: 'Prepayment Register',
    applicationForm: 'Payment Application',
    outlineAgreement: 'Frame Protocal',
    alarmSystem: 'Report & Filing Record',
    actualPayment: 'Actual Payment',
    receivableRegister: 'Receivable Register',
    transactionAmount: 'Configuration',
    tradeStatistics: 'Statistics',
    contractManagement: 'Non-CP Contract',
    generalContract: 'Non-CP Contract',
    foreignShipManagement: 'External Ship-Management',
    feeRegistration: 'Expense Register',
    accountApproval: 'Expense Approve',
    budgetManagement: 'Budget Control',
    costAccountManagement: 'Account Code',
    standardCode: 'Standardized Code',
    countyInfo: 'Country/Region',
    GoodsType: 'Cargo Type',
    currency: 'Currency',
    rateAssert: 'Exchange Rate',
    portAssert: 'Port Info',
    costAccount: 'Cost Account',
    cityInformation: 'City',
    bankInformation: 'Bank Info',
    companyInformation: 'Company',
    aclTable: 'aclTable',
    /* 船岸同步 */
    VesselMaintenanceManage: 'VesselMaintenanceManage',
    // 预算管理
    budget: 'Budget',
    annualBudget: 'Annual Budget',
    rollBudget: 'Rolling Budget',
    additionalBudget: 'Additional Budget',
    budgetControlAnalysis: 'Budget Control',
    budgetReportStatistics: 'Budget Performance ',
    stockBase: 'Basic Data',
    // 相关方管理
    interestedParties: 'Interested Party',
    integratedManage: 'Interested Party',
    supplierManage: 'Supplier',
    otherPartiesManage: 'Others',
    customerManage: 'Customer',
    timeAssessment: 'TimeAssessment',
    frequencyConfiguration: 'Frequency Configuration',
    evaluationMonitor: 'Assessment',
    activityType: 'activityType',
    workPlan: 'Work Plan',
    workPlanConfirm: 'WorkPlanConfirm',
    workBeforeConfirm: 'WorkBeforeConfirm',
    completedFill: 'CompletedFill',
    completedExamine: 'CompletedExamine',
    meeting: 'Meeting',
    meetingManager: 'Meeting minutes',
    meetingMonitor: 'Resolution Monitor',
    meetingHistory: 'History Resolution',
    shipMeetingDefine: 'Vessel Meeting Agenda',
    shipMeeting: 'Vessel Meeting',
    shoreMeeting: 'Vessel Meeting Monitor',
    vesselMeeting: 'Vessel Meeting Management',
    audit: 'Audit & Inspection',
    shoreAuditPlan: 'Company Audit Plan',
    shipAuditPlan: 'Vessel Audit Plan',
    auditor: 'Auditor Management',
    shoreInnerAudit: 'Company Internal Audit',
    shoreExternalAudit: 'Company External Audit',
    shipInnerAudit: 'Vessel Internal Audit',
    shipExternalAudit: 'Vessel External Audit',
    onboardInspect: 'Boarding Inspection',
    externalInspect: 'External Inspection',
    risk: 'Risk Manageent',
    riskLib: 'Risk database',
    riskAssess: 'Risk Assessment',
    emergency: 'Emergency Management',
    drillTrainDefine: 'Drills/Training Item',
    emergencyPlanScene: 'Emergency Scenario',
    emergencyPlanHandle: 'Emergency & Accident',
    emergencyPreparedness: 'Emergency',
    accidentHandling: 'Accident',
    hiddenDanger: 'Potential Risk & Near Miss',
    hidden: 'Potential Risk',
    hiddenMonitor: 'Potential Risk Monitor',
    danger: 'Near Miss',
    dangerMonitor: 'Near Miss Monitor',
    antiPollution: 'Pollution Prevention',
    bilgeWater: 'Bilge Water',
    garbageDispose: 'Garbage',
    preventAir: 'Air Pollution Prevention',
    portFacility: 'Inadequacy of Facilities',
    nonconform: 'Non Conformity',
    ncRecord: 'N.C Management',
    ncReport: 'N.C Analysis Report',
    marine: 'Marine',
    voyVessel: 'Voyage Management',
    marineCompanyChart: 'Company Charts & Publication',
    marineChart: 'Charts & Publication',
    marineVoyNewRoute: 'New Route/Ports',
    marineVoyTrack: 'Voyage Tracking',
    deviceMgt: 'Equipment',
    devicePeriod: 'Maintenance Period ',
    deviceCategory: 'Category ',
    shipDeviceMgt: 'Vessel Equipment Management',
    shipDeviceQuery: 'Vessel Equipment Info',
    deviceStandard: 'CWBT Code',
    deviceProduct: 'Equipment Product',
    composeWork: 'Group Jobs',
    timerMgt: 'Timer',
    timerUpdate: 'Update Timer',
    timerDefine: 'Timer Management',
    arrangeWork: 'Commence Date',
    performWork: ' Plan & Excution',
    deviceFault: 'Equipment Malfunction',
    planReport: 'Plan & Report',
    manufacture: 'Manufacture',
    workCard: 'Work Order',
    reportHistory: 'Work History',
    resWorkCard: 'Remain Work ',
    cancelWorkCard: 'Canceled Work ',
    safetyDevice: 'Safety Equipment ',
    standardCheckWork: 'Standardization',
    safetyDevicesInventory: 'Safety Equipment List',
    regularInspection: 'Periodic Check',
    regularInspectionRecord: 'Periodic Check Record',
    shipCertDict: 'Cert. Dictionary',
    safety: 'Safety',
    financeManage: 'Finance and Business ',
    ruleConfig: 'Configuration',
    fiReceiptsManage: 'Universal Bill',
    financeDataSearch: 'Data Summary',
    financeOrder: 'Purchase Order',
    dockSearch: 'Dock Repair',
    receiptMonth: 'Stock Statistics ',
    fiReceiptSearch: 'Universal Bill',
    dataMonitor: 'Exchange Monitor',
    sendMonitor: 'Transmit',
    recieveMonitor: 'Receive',
    fiBizInOut: '库存动态',
    accountGroupManage: 'Project Team'
  },
  navbar: {
    dashboard: 'Dashboard',
    changeRole: 'Change Role',
    logOut: 'Log Out',
    profile: 'Account Info',
    modifyPassWord: 'Change Password',
    operateLogs: 'Logs Of Operation',
    adviseFeedBack: 'Feed Back',
    aboutUs: 'About Us',
    theme: 'Theme',
    size: 'Global Size',
    AccountNo: 'Account No',
    LoginName: 'Login Name',
    ChineseName: 'Chinese Name',
    AccountID: 'Account ID',
    defaultRole: 'Default Role',
    AffiliatedOrganization: 'Affiliated Organization',
    AffiliatedOrganizationID: 'Affiliated Organization Id',
    Organizationcode: 'Organization Code',
    position: 'Position',
    Numberofvisits: 'Number Of Visits',
    Recentlyloggedin: 'Recently Logged In',
    chooseMonth: 'Select Month'
  },
  login: {
    title: 'Login Form',
    logIn: 'Login',
    signIn: 'SIGN IN',
    username: 'Account',
    password: 'Password',
    checkCode: 'CAPTCHA',
    userHolder: 'Enter Account.',
    passwordHolder: 'Enter Password.',
    capsLock: 'Caps Lock',
    checkCodeHolder: 'Enter CAPTCHA',
    userError: 'Account Is Mandatory',
    passwordRequire: 'Password Is Mandatory',
    passwordError: 'Password at Least 8 Characters',
    checkRequire: 'CAPTCHA Is Required',
    checkError: 'CAPTCHA Is 4 Characters',
    loginErrTip: 'Account Or Password Error',
    loginServerErrTip: 'System failure, please contact the administrator to deal with it',
    resetTip: 'The Password Has Expired. Please Set a New Password.',
    giveUp: 'Give Up to Modify',
    resetPassword: 'Change Password',
    newPassword: 'New Password',
    oldPassword: 'Old Password',
    confirmPassword: 'Confirm Password',
    confirmModify: 'Confirm Modify',
    modifyTip: 'The password has expired, please reset the password',
    oldPwd: 'Please enter the original password',
    newPwd: 'Please enter the new password',
    verifyNewPwd: 'Enter the new password again',
    resendActivationEmail: 'Resend activation email'
  },
  permission: {
    addRole: 'New Role',
    editPermission: 'Edit',
    roles: 'Your roles',
    switchRoles: 'Switch roles',
    tips: 'In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  guide: {
    description: 'The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ',
    button: 'Show Guide'
  },
  components: {
    documentation: 'Documentation',
    tinymceTips: 'Rich text is a core feature of the management backend, but at the same time it is a place with lots of pits. In the process of selecting rich texts, I also took a lot of detours. The common rich texts on the market have been basically used, and I finally chose Tinymce. See the more detailed rich text comparison and introduction.',
    dropzoneTips: 'Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.',
    stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.',
    backToTopTips1: 'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner',
    backToTopTips2: 'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally',
    imageUploadTips: 'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.'
  },
  table: {
    dynamicTips1: 'Fixed header, sorted by header order',
    dynamicTips2: 'Not fixed header, sorted by click order',
    dragTips1: 'The default order',
    dragTips2: 'The after dragging order',
    title: 'Title',
    importance: 'Imp',
    type: 'Type',
    remark: 'Remark',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    reviewer: 'reviewer',
    id: 'ID',
    date: 'Date',
    author: 'Author',
    readings: 'Readings',
    status: 'Status',
    actions: 'Operation',
    edit: 'Edit',
    publish: 'Publish',
    draft: 'Draft',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    emptyText: 'No Data',
    No: 'No.'
  },
  example: {
    warning: 'Creating and editing pages cannot be cached by keep-alive because keep-alive include does not currently support caching based on routes, so it is currently cached based on component name. If you want to achieve a similar caching effect, you can use a browser caching scheme such as localStorage. Or do not use keep-alive include to cache all pages directly. See details'
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export Selected Items',
    placeholder: 'Please enter the file name (default excel-list)',
    exportSuccess: 'Export Success',
    chooseOneMsg: 'Please select the data to be exported.',
    exportAll: 'Export All',
    exportSelection: 'Export Selection'
  },
  zip: {
    export: 'Export',
    placeholder: 'Please enter the file name (default file)'
  },
  pdf: {
    tips: 'Here we use window.print() to implement the feature of downloading PDF.'
  },
  theme: {
    change: 'Change Theme',
    documentation: 'Theme documentation',
    tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    tagsView: 'Open Tags-View',
    fixedHeader: 'Fixed Header',
    sidebarLogo: 'Sidebar Logo'
  },
  /* ke拖拽弹窗 */
  dragDialog: {
    fullScreen: 'fullscreen',
    restore: 'restore',
    close: 'close',
    readFlag: 'read Flag',
    focus: 'follow',
    unFocus: 'unfollow'
  },
  btn: {
    viewHistory: 'View Historical Version',
    update: 'Update',
    add: 'Add',
    authorize: 'Authorize',
    batchDel: 'Batch Delete',
    del: 'Delete',
    edit: 'Edit',
    save: 'Save',
    submit: 'Submit',
    download: 'Download',
    export: 'Export',
    exportTemplate: 'Export(Template)',
    import: 'Import',
    print: 'Print',
    reset: 'Reset',
    option: 'Operation',
    send: 'Send',
    confirm: 'Confirm',
    close: 'Close',
    activate: 'Activate',
    cancel: 'Cancel',
    search: 'Search',
    invalid: 'Invalid',
    menuEdit: 'MenuEdit',
    versionEdit: 'VersionEdit',
    historyEdit: 'HistoryEdit',
    moduleEdit: 'ModuleEdit',
    requireFlag: 'requireFlag',
    validFlag: 'Validflag',
    typeEdit: 'TypeEdit',
    initialAssessment: 'Initial Assessment',
    timeAssessment: 'Time Assessment',
    sendMasterData: 'Send MasterData',
    authorityAss: 'Authorityass',
    blackList: 'Blacklist',
    copyAdd: 'Copy Add',
    addShop: 'Add Shop',
    statisticalSummary: 'Statistical Summary',
    cancelCancellation: 'Cancel Cancellation',
    cancellation: 'Cancellation',
    orgMigration: 'OrgMigration',
    templateDownload: 'Template Download',
    monthPlanAdd: 'Month PlanAdd',
    monthReportAdd: 'Month Report Add',
    yearPlanAdd: 'yearPlanAdd',
    batchInspection: 'batchInspection',
    aloneReport: 'Alone Report',
    maintenanceCode: 'Maintenance Code',
    adjustCode: 'Adjustcode',
    generate: 'Generate',
    writeOff: 'Generate WriteOff Voucher',
    section: 'Section',
    delSection: 'DelSection',
    copy: 'Copy',
    clear: 'Clear',
    next: 'Next',
    up: 'Up',
    newApply: 'newApply',
    saveApply: 'SaveApply',
    invalidApply: 'Invalid Apply',
    createTransfer: 'createTransfer',
    newInquiry: 'newInquiry',
    submitInquiry: 'submitInquiry',
    invalidInquiry: 'invalidInquiry',
    fillQuote: 'fillQuote',
    importQuote: 'importQuote',
    crewOnBoard: 'Crew On Board',
    crewOnVacation: 'crewOnVacation',
    invalidQuote: 'invalidQuote',
    newCompare: 'newCompare',
    editCompare: 'newCompare',
    savePo: 'savePo',
    invalidPo: 'savePo',
    sendPo: 'sendPo',
    confirmPo: 'confirmPo',
    saveDelivery: 'saveDelivery',
    confirmStock: 'confirmStock',
    saveReceive: 'saveReceive',
    confirmReceive: 'confirmReceive',
    scoreReceive: 'scoreReceive',
    saveTransfer: 'saveTransfer',
    invalidTransfer: 'invalidTransfer',
    newTransfer: 'newTransfer',
    new: 'add',
    updataChartVer: '更新最新版本',
    addVoyage: '新增航次计划',
    addCargoPort: '获取装卸货港口',
    editCargoPort: '编辑装卸货港口',
    lookCargoPort: '查看装卸货港口',
    addBunker: '新增油类转移操作',
    editBunker: '编辑油类转移操作',
    delBunker: '删除油类转移操作',
    lookBunker: '查看油类转移操作',
    addSupplier: '新增供应商',
    spare: 'spare',
    relevantData: 'relevantData',
    transfer: 'Transfer',
    look: 'view details',
    newTeam: 'newTeam',
    viewAccount: 'viewAccount',
    newShip: 'newShip',
    delShip: 'delShip',
    changeTeam: 'changeTeam',
    chooseAccount: 'chooseAccount',
    manageDel: 'manageDel',
    manageChangeTeam: 'manageChangeTeam',
    changeTime: 'Change Time',
    createInfo: 'Create Info',
    newAccount: 'newAccount',
    delAccount: 'delAccount',
    changeAccount: 'changeAccount',
    change: 'change',
    permit: 'permit',
    addPart: 'addPart',
    delPart: 'delPart',
    shipPriciple: 'Shippriciple',
    valid: 'Valid',
    reSend: 'Re Send',
    temp: 'Temp',
    addNode: 'Add Node',
    addTracking: 'Add Tracking',
    sendMain: 'Send Main platform',
    detail: 'Detail',
    inStock: 'inStock',
    outStock: 'outStock',
    initStock: 'initStock',
    back: 'Back',
    markRead: 'Mark Read',
    upload: 'Upload',
    exportCurrentPage: 'Export Current Page',
    attachmentUpload: 'Attachment upload',
    downloadAttachments: 'Download attachments',
    deleteAttachment: 'Delete attachment',
    preview: 'preview',
    create: 'create',
    foreSpeak: 'Appoint',
    forespeakSave: 'Appoint/Save',
    downloadAttorney: 'Letter Of Attorney Download',
    accreditSave: 'Accredit/Save',
    nextStep: 'next',
    previousStep: 'Back',
    confirmPrint: 'Confirm Print',
    feeConfirmation: 'Fee Confirmation',
    bankSlipUpload: 'Bank Slip Upload',
    bankSlipUploadPlus: 'Invoiced&Bank Slip Upload',
    applyInvoice: 'Apply Invoice',
    uploadInvoice: 'Bank Slip Upload/Apply Invoice',
    refresh: 'Refresh',
    batchPrint: 'Batch Print',
    batchCancelAppointment: 'Cancel Appointments',
    cancelAppointment: 'Cancel Appointment',
    cancelAccredit: 'Cancel'
  },
  /* 面板 */
  panel: {
    refresh: 'Refresh',
    edit: 'Edit',
    hidden: 'Hidden',
    addModule: 'Add Module',
    recover: 'Recover'
  },
  /* 联想控件 */
  associate: {
    placeholder: 'Select',
    countryCode: 'CountryCode',
    countryNameCn: 'CountryNameCn',
    countryNameEn: 'CountryNameEn',
    provinceCode: 'ProvinceCode',
    provinceNameCn: 'ProvinceNameCn',
    provinceNameEn: 'ProvinceNameCn',
    currencyCode: 'currencyCode',
    currencyName: 'currencyName',
    currencySymbol: 'currencySymbol',
    portCode: 'PortCode',
    portNameEn: 'PortNameEn',
    portNameCn: 'PortNameCn',
    portCountry: 'countryCode',
    portCountryNameCn: 'PortCountryNameCn',
    portCountryNameEn: 'PortCountryNameEn',
    chargeCode: 'ChargeCode',
    chargeName: 'ChargeName',
    chargeNameCn: 'ChargeNameCn',
    childFlag: 'ChildFlag',
    displayValueCn: 'DisplayvalueCn',
    displayValue: 'Displayvalue',
    cargoCode: 'Cargo Code',
    cargoName: 'Cargo Name',
    cargoNameCn: 'Cargo NameCn',
    officeCode: 'Office Code',
    officeName: 'Office Name',
    parentOfficeCode: 'Parentoffice Code',
    parentOfficeName: 'Parentoffice Name',
    officeType: 'Office Type',
    roleCode: 'Role Code',
    roleName: 'Role Name',
    parentRoleCode: 'Parentrole Code',
    parentRoleName: 'Parentrole Name',
    vesselOfficeName: 'Office Name',
    vesselTeamCode: 'Vesselteam Code',
    vesselTeamName: 'Vesselteam Name',
    vesselCode: 'Vessel Code',
    vesselEnName: 'Vessel Name(EN)',
    vesselCnName: 'Vessel Name',
    vesselType: 'Vessel Type',
    validFlag: 'Valid Flag',
    ownership: 'Ownership',
    onService: 'Onservice',
    unService: 'Unservice',
    onBuilding: 'Onbuilding',
    companyCode: 'Company Code',
    companyName: 'Company Name',
    companyNameCn: 'Company NameCn',
    companyNameEn: 'Company NameEn',
    parentCompanyCode: 'Parentcompany Code',
    parentCompanyName: 'Parentcompany Name',
    deptCode: 'Dept Code',
    deptName: 'Dept Name',
    ripCode: 'Rip Code',
    hcbCode: 'Hcb Code',
    ripNameCn: 'Rip NameCn',
    ripNameEn: 'Rip NameEn',
    shipOwnerNameCn: 'Shipowner Name(CN)',
    shipOwnerNameEn: 'Shipowner Name(EN)',
    shipManageCompanyNameCn: 'Company Name(CN)',
    shipManageCompanyNameEn: 'Company Name(EN)',
    operateCompanyNameCn: 'Company Name(CN)',
    operateCompanyNameEn: 'Company Name(EN)',
    singleCompanyCn: 'Company（CN）',
    singleCompanyEn: 'Company（EN）',
    locationCode: 'Location Code',
    locationNameCn: 'Location Name(CN)',
    locationNameEn: 'Location Name(EN)',
    cityCode: 'City Code',
    cityNameCn: 'City Name(CN)',
    cityNameEn: 'City Name(EN)',
    province: 'Province',
    countryCodePlace: 'Country Code',
    userCode: 'User Code',
    userName: 'User Name(CN)',
    userNameEn: 'user Name(EN)',
    defaultOfficeName: 'Defaultoffice Name',
    defaultRoleName: 'Defaultrole Name',
    poNo: 'Order No',
    orderDate: 'Order Date',
    currency: 'Currency',
    amount: 'Amount',
    receiveStatus: 'Receive Status',
    employeeNo: 'Employee No',
    cnName: 'Name(CN)',
    enName: 'Name(EN)',
    filterYes: 'Yes',
    filterNo: 'No',
    planYear: 'Plan Year',
    repairType: 'Repair Type',
    planDate: 'Plan Date',
    planDay: 'Plan Day',
    sipgCstCode: 'Sipg Cst Code',
    creditCode: 'Credit Code',
    cstName: 'Cst Name'
  },
  form: {
    dateTitle: 'From',
    to: 'to',
    startTime: 'startTime',
    endTime: 'endTime',
    startDate: 'startDate',
    endDate: 'endDate',
    search: 'Search',
    reset: 'Reset',
    send: 'Send',
    close: 'Close'
  },
  filter: {
    quickSearch: 'Quick Search',
    filter: 'Filter',
    keySearch: 'Keyword Search',
    pleaseEnterKeyWord: 'Please Enter Keyword',
    placeholder: 'select',
    dataNone: 'date none',
    startDate: 'Start Date',
    endDate: 'End Date',
    selected: 'Selected:',
    unSelected: 'UnSelected',
    start: 'Start',
    end: 'End',
    from: 'from',
    to: 'to',
    today: 'Today',
    week: 'Last Week',
    mouth: 'Last Month',
    year: 'Last Year'
  },
  dict: 'displayValue',
  labelTitle: 'titleEn',
  confirmMsg: {
    title: 'Tips',
    submit: 'Submit',
    cancel: 'Cancel',
    close: 'Close',
    confirm: 'Confirm'
  },
  /* 图片预览组件 */
  imagesViewer: {
    originalImageBtn: 'View Original Image',
    applyOriginImage: 'Apply Original Image',
    transitImage: 'The original image is in transit',
    isApplyForOriginImage: 'Whether to apply for resale of original drawings',
    isApplySuccess: 'Application successful, waiting to return to the original'
  },
  validMsg: {
    msg: 'The data you entered is incorrect, please correct '
  },
  status: {
    all: 'All',
    draft: 'Draft',
    approving: 'Approving',
    approved: 'Approved',
    applying: 'Applying',
    reject: 'Reject',
    submit: 'Submit',
    viewDetail: 'View Detail'
  },
  treeSelet: {
    placeholder: 'Please Select'
  },
  tips: {
    inputChineseTip: 'Only non Chinese characters are accepted.',
    saveTip: 'The current page modification is not saved. Do you want to close it?',
    title: 'Prompt',
    submit: 'Confirm',
    cancel: 'Cancel',
    submitTip: 'Confirm to submit the record',
    delTip: 'Are you sure to delete this record',
    delSuccess: 'Successfully deleted',
    delFail: 'Failed to Delete',
    saveSuccess: 'Saved successfully',
    saveFail: 'Save failed',
    submitSuccess: 'Submitted successfully',
    submitFail: 'Submission Failed',
    restoreTips: 'Confirm to restore the layout',
    restoreTips1: 'Confirm',
    restoreTips2: 'Yes',
    restoreTips3: 'No'
  },
  loading: {
    save: 'Saving...',
    loading: 'Loading...',
    submit: 'Submitting...',
    send: 'Sending...',
    export: 'Exporting...'
  },
  flollow: {
    followSuccess: 'Follow Successfully!',
    followCancel: 'UnFollow Successfully!'
  }
};